import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoWarningOutline } from "react-icons/io5";
import { getHraSubmissionStatus } from "../api/hra.api";
import { getStaffId } from "../utils/storage";

const HraAlertBanner = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const staffId = getStaffId();

  useEffect(() => {
    if (!staffId) {
      setVisible(false);
      return;
    }

    getHraSubmissionStatus(staffId)
      .then((response) => {
        const data = response?.data?.data;

        // Hide the banner if the assessment was already completed
        // within the last 30 days.
        if (data?.hasTakenInLast30Days || !data?.canTakeHra) {
          setVisible(false);
        } else {
          setVisible(true);
        }
      })
      .catch((error) => {
        console.error("Error fetching HRA submission status:", error);
        setVisible(false);
      });
  }, [staffId]);

  if (!visible) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-2xl bg-error-container">
      <div className="flex items-start gap-3">
        <IoWarningOutline className="text-tertiary shrink-0 mt-0.5" size={22} />
        <div>
          <p className="font-semibold text-on-primary-fixed-var">
            Complete your {new Date().getFullYear()} Assessment
          </p>
          <p className="text-sm text-on-primary-fixed-var/70 mt-0.5">
            Your annual health risk assessment is due in 5 days. Complete it to maintain your corporate wellness benefits.
          </p>
        </div>
      </div>

      <button
        onClick={() => navigate("/hra-category")}
        className="shrink-0 bg-tertiary text-white font-semibold rounded-full px-5 py-2 text-sm hover:opacity-90 transition"
      >
        Start Now
      </button>
    </div>
  );
};

export default HraAlertBanner;